import { h, Component } from 'preact';
import '../utils/pubSub';
import camelizeKeys from 'camelize-keys';
import SignIn from './SignIn';
import UserInfo from './UserInfo';
import getSession from '../utils/getSession';
import parseHiddenProp from '../utils/parseHiddenProp';
import mixpanelTracker from '../utils/mixpanelTracker';
import apiConfig from '../../config/apiConfig';

export default class Root extends Component {
  constructor (props) {
    super(props);
    this.setOrigin();
    this.session = getSession();
    this.state = {
      isLoading: true, // Flag que indica si debe mostrar la leyenda "cargando"
      userInfo: undefined, // Informacion del usuario
    };
  }

  componentDidMount () {
    const { variant = 'link', startupOnMount = true } = this.props;
    const pubSub = window.reservamosPubSub;

    this.mixpanelTracker = mixpanelTracker(variant);

    this.dispose = pubSub.sub('siempreplus', ({ user, loading }) => {
      if (typeof loading === 'boolean') {
        this.setState({ isLoading: loading });
      }

      this.setState({ userInfo: user });
      if (window.SearchWidget) {
        window.SearchWidget.setRecentTrips(user ? camelizeKeys(user.trips) : []);
      }
    });

    const siempreplus = pubSub.value('siempreplus');
    if (siempreplus) {
      this.setState({
        isLoading: Boolean(siempreplus.loading),
        userInfo: siempreplus.user,
      });
      return;
    }

    if (startupOnMount === true || startupOnMount === 'true') {
      this.start();
    } else {
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount () {
    this.dispose();
  }

  setOrigin () {
    const { origin } = this.props;
    apiConfig.origin = origin;
  }

  start () {
    const pubSub = window.reservamosPubSub;
    const isLoggingIn = Boolean(pubSub.value('siempreplus'));

    if (isLoggingIn) return;

    pubSub.pub('siempreplus', {
      loading: true,
      user: null,
      error: null,
    });

    this.session.getProfile()
      .then((user) => {
        pubSub.pub('siempreplus', {
          user,
          loading: false,
          error: null,
        });
      })
      .catch((error) => {
        pubSub.pub('siempreplus', {
          user: null,
          loading: false,
          error,
        });
      });
  }

  updateUserInfo (userInfo, extras = {}) {
    this.setState({ userInfo, ...extras });
  }

  render ({
    insistLogin,
    hidden = '',
    invitationText,
    buttonText,
    modifierClass = '',
    variant = 'link',
  }) {
    const { userInfo, isLoading } = this.state;
    const hide = parseHiddenProp(hidden);

    const signOut = () => {
      this.setState({ userInfo: null });
    };

    if (hide.onLoading && isLoading) return null;

    if (hide.withSession && userInfo) return null;

    // Si no tiene sesion y tiene la configuracion de ocultar si no tiene sesion, retorna null
    if (hide.withoutSession && !userInfo) return null;

    const hasInsistLoginAtUrl = window && window.location.search.includes('insist-login');

    return (
      <div className="w-siempre-plus">
        {userInfo ? (
          <UserInfo
            variant={variant}
            user={userInfo}
            signOut={signOut}
            session={this.session}
            mixpanelTracker={this.mixpanelTracker}
            modifierClass={modifierClass}
          />
        ) : (
          <SignIn
            variant={variant}
            session={this.session}
            mixpanelTracker={this.mixpanelTracker}
            modifierClass={modifierClass}
            invitationText={invitationText}
            buttonText={buttonText}
            isLoading={isLoading}
            insistLogin={insistLogin === 'true' && hasInsistLoginAtUrl}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Root.js